import { Fab, styled, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { FC } from 'react';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { getLogoByHostname } from 'src/utils/getLogoByHostname';

interface Props {
  title?: string;
  subTitle?: string;
  onClickBack?: () => void;
}

const Container = styled(Box)(
  ({ theme }) => `
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: ${theme.spacing(5, 0, 3, 0)};
    `
);

const HeaderBasicLayout: FC<Props> = ({ title, subTitle, onClickBack }) => {
  const theme = useTheme();
  const { logo, width } = getLogoByHostname(true);

  return (
    <Container>
      {onClickBack && (
        <Fab
          onClick={onClickBack}
          size="small"
          sx={{
            position: 'fixed',
            left: theme.spacing(23),
            top: theme.spacing(5)
          }}
        >
          <KeyboardBackspaceIcon />
        </Fab>
      )}
      <Box sx={{ mb: theme.spacing(0) }}>
        <img src={logo} alt="logo" style={{ width: width }} />
      </Box>
      {title && (
        <Box sx={{ mb: theme.spacing(1) }}>
          <Typography variant="h2">{title}</Typography>
        </Box>
      )}
      {subTitle && (
        <Box sx={{ mb: theme.spacing(1) }}>
          <Typography variant="subtitle2">{subTitle}</Typography>
        </Box>
      )}
    </Container>
  );
};

export default HeaderBasicLayout;
